import React, { Component, Fragment } from 'react';
import ErrorContainer from '../components/utils/ErrorContainer';
import Portlet from '../components/utils/Portlet';
import cn from 'classnames';
import { connect } from 'react-redux';
import { setUIvisible } from '../action/UImobile';
import { roleId } from '../constants/app';
import Revenue from '../components/reports/Revenue';
import Purchase from '../components/reports/Purchase';
import RevenuePromotions from '../components/reports/RevenuePromotions';
import RevenuePromocodes from '../components/reports/RevenuePromocodes';
import SalesHours from '../components/reports/SalesHours';
import FirstOrders from '../components/reports/FirstOrders';
import Cashback from '../components/reports/Cashback';
import DeletedUsers from '../components/reports/DeletedUsers';
import CostpriceReport from '../components/reports/CostpriceReport';
import DeliveryReport from '../components/reports/DeliveryReport';
import DynamicsPrices from '../components/reports/DynamicsPrices';
import SalesReport from '../components/reports/SalesReport';
import StagesOrders from '../components/reports/StagesOrders';
import ABCAnalysis from '../components/reports/ABCAnalysis';
import CashbackNew from '../components/reports/CashbackNew';
import Costprice from '../components/statistics/Costprice';
import HistoryInvoice from '../components/statistics/HistoryInvoice';
import MovementRaws from '../components/statistics/MovementRaws';
import UnactiveClients from '../components/reports/UnactiveClients';
import IncomeStatement from '../components/reports/IncomeStatement';
import ConsumptionSemi from '../components/reports/ConsumptionSemi';

const statisticsComponents = {
    revenue: { title: 'Выручка', component: Revenue, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist, roleId.cashier] },
    revenuePromotions: { title: 'Выручка акции', component: RevenuePromotions, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    revenuePromocodes: { title: 'Выручка промокоды', component: RevenuePromocodes, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    salesHours: { title: 'Продажи по часам', component: SalesHours, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    firstOrders: { title: 'Первичные заказы', component: FirstOrders, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    purchase: { title: 'Закупка', component: Purchase, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist] },
    cashback: { title: 'Бонусные баллы (ст.лог)', component: Cashback, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    cashbackNew: { title: 'Бонусные баллы (нов.лог)', component: CashbackNew, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    deletedUsers: { title: 'Удаленные клиенты', component: DeletedUsers, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    costprice: { title: 'Себестоимость по заказам', component: CostpriceReport, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist] },
    delivery: { title: 'Доставка', component: DeliveryReport, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    dynamicsPrices: { title: 'Динамика цен сырье', component: DynamicsPrices, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist] },
    sales: { title: 'Сводный отчет по продажам', component: SalesReport, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist] },
    stagesOrders: { title: 'Время по этапам', component: StagesOrders, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    abcAnalysis: { title: 'ABC анализ', component: ABCAnalysis, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist] },
    costpriceGoods: { title: 'Себестоимость по товарам и п/ф', component: Costprice, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist]},
    historyInvoice: { title: 'История закупок', component: HistoryInvoice, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist]},
    movementRaws: { title: 'Движение сырья', component: MovementRaws, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist]},
    consumptionSemi: { title: 'Расход полуфабрикатов', component: ConsumptionSemi, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.commodityExpert, roleId.chiefCommoditySpecialist]},
    unactiveClients: { title: 'Неактивные клиенты', component: UnactiveClients, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
    incomeStatement: { title: 'Финансовый ОПиУ', component: IncomeStatement, access: [roleId.admin, roleId.manager, roleId.accountant, roleId.marketingSpecialist, roleId.regionalDirector, roleId.chiefAccountant, roleId.chiefMarketingSpecialist, roleId.operationDirector, roleId.chiefCommoditySpecialist] },
};

function EmptyPage() {
    return (
        <Portlet >
            <div style={{
                minHeight: 250,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 18
             }}>
                <div>Выберите необходимый раздел</div>
            </div>
        </Portlet>
    );
}


class ReportsPage extends Component {
    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();
        this.state = {
            hasScrollLeft: false,
            hasScrollRight: false,
        };
    }

    state = {
        mode: null
    }

    componentDidMount(){
        this.props.setUIvisible(false, false);
        this.updateScrollIndicators();
        window.addEventListener('resize', this.updateScrollIndicators);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScrollIndicators);
    }

    updateScrollIndicators = () => {
        const { current } = this.scrollRef;
        if (current) {
            const scrollLeft = current.scrollLeft;
            const scrollWidth = current.scrollWidth;
            const clientWidth = current.clientWidth;

            this.setState({
                hasScrollLeft: scrollLeft > 0,
                hasScrollRight: scrollLeft + clientWidth < scrollWidth,
            });
        }
    };

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Отчеты</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                       
                    </div>
                </div>
            </div>
            </div>
        );
    }

    onClickItem = (mode) => (e) => {
        this.setState({ mode });
    }

    render() {
        const StaticticsComponent = this.state.mode ? statisticsComponents[this.state.mode].component : EmptyPage;
        const { hasScrollLeft, hasScrollRight } = this.state;

        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <ErrorContainer field="reports" style={{ margin: 15 }} hasCloseButton={true}/>
                    <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop  kt-todo" id="kt_todo">
                        <div className="kt-grid__item   kt-portlet kt-todo__aside statistic" id="kt_todo_aside" style={{ opacity: 1 }}>
                            <div className="kt-todo__nav statistic">
                                {hasScrollLeft && 
                                    <div style={{
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: '10px',
                                        background: 'linear-gradient(to right, rgba(0, 0, 0, 0.23), rgba(0, 0, 0, 0))',
                                        zIndex: 1
                                    }} />
                                }
                                <ul 
                                className="kt-nav statistic"
                                ref={this.scrollRef}
                                onScroll={this.updateScrollIndicators}
                                >
                                    {
                                        Object.keys(statisticsComponents).filter((key) => !statisticsComponents[key].access || statisticsComponents[key].access.includes(this.props.user.role.id)).map(key => (
                                            <li key={key} onClick={this.onClickItem(key)} className={cn({ 'kt-nav__item': true, 'kt-nav__item--active': key === this.state.mode })}>
                                                <span className="kt-nav__link statistic" data-action="list">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon kt-nav__link-icon statistic">
                                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24"/>
                                                            <path d="M12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 Z M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z" fill="#000000"/>
                                                            <path d="M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 Z" fill="#000000" opacity="0.3"/>
                                                        </g>
                                                    </svg>                                                    
                                                    <span className="kt-nav__link-text statistic">{statisticsComponents[key].title}</span>
                                                </span>
                                            </li>
                                        ))
                                    }
                                </ul>
                                {hasScrollRight && 
                                    <div style={{
                                        position: 'absolute',
                                        right: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: '10px',
                                        background: 'linear-gradient(to left, rgba(0, 0, 0, 0.23), rgba(0, 0, 0, 0))',
                                        zIndex: 1
                                    }} />
                                }
                            </div>
                        </div>
        
                        <div className="kt-grid__item kt-grid__item--fluid kt-todo__content" id="kt_todo_content" style={{ flex: '1 auto !important' }}>
                            <div className="kt-todo__tasks-bottom">
                                <StaticticsComponent />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user.info,
});


const mapDispatchToProps = {
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsPage);